module.exports = __webpack_public_path__ + "img/11.c236fa21.svg";